import {
  isString,
  isObject,
  compose,
} from 'lodash/fp';
import { API } from '.';
import { getServerOrigin } from './utils';
import {
  convertDataToFormData,
  snakeifyData,
  serializeData,
  logRequestBreadcrumb,
  extractData,
  determineError,
  serializeParams,
} from './middleware';

export const asFormDataRequest = (api: API): API => (
  api
    .withMiddleware(convertDataToFormData)
);

export const asJsonRequest = (api: API): API => (
  api
    .withHeaders({
      'Content-Type': 'application/json',
    })
    .withMiddleware((next) => (reqData) => {
      if (isString(reqData.data)) {
        return next({
          ...reqData,
          data: reqData.data,
        });
      }

      if (isObject(reqData.data)) {
        return next({
          ...reqData,
          data: JSON.stringify(reqData.data),
        });
      }

      return next(reqData);
    })
);

export const asFormRequest = (api: API): API => (
  api
    .withHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    })
    .withMiddleware(serializeData)
);

export const createRgAPI = (path: string): API => new API({
  path,
  base: getServerOrigin(path),
  middleware: [
    snakeifyData,
    serializeParams,
    logRequestBreadcrumb,
    extractData,
    determineError,
  ],
}).withCredentials();


export const createRgFormAPI: (path: string) => API = compose([
  asFormRequest,
  createRgAPI,
]);

export const createRgFormDataAPI: (path: string) => API = compose([
  asFormDataRequest,
  createRgAPI,
]);

export const createRgJsonAPI: (path: string) => API = compose([
  asJsonRequest,
  createRgAPI,
]);
